import { inject, Injectable } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { IService } from '../models/service.interface';
import { SiteContract } from '../models/site-contract.model';
import { FirestoreService } from './firestore.service';

const itemCollection = 'site-contracts';

@Injectable({
  providedIn: 'root',
})
export class SiteContractsService implements IService<SiteContract> {
  private firestore = inject(FirestoreService);

  async save(item: SiteContract) {
    return this.firestore.save<SiteContract>(itemCollection, item);
  }

  async update(item: SiteContract) {
    return this.firestore.update(itemCollection, item);
  }

  async updateOnly(guid: string, item: object) {
    return this.firestore.updateOnly(itemCollection, guid, item);
  }

  async delete(item: SiteContract) {
    return this.firestore.delete(itemCollection, item);
  }

  get(guid: string) {
    return this.firestore.get<SiteContract>(itemCollection, guid);
  }

  getList(options?: { site?: string }) {
    const queryConstraints = [];
    if (options?.site) {
      queryConstraints.push(where('site', '==', options.site));
    }

    return this.firestore
      .getList<SiteContract>(itemCollection, undefined, queryConstraints)
      .pipe(map((results) => results ?? []));
  }
}
